import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

import DashboardInfo from 'components/DashboardInfo';
import Logo from 'components/Logo';
import Navigation from 'components/Navigation';

interface HeaderProps {
    dashboardId: string | null;
    dashboardName: string | null;
    dashboardLastUpdatedAt: Date | null;
    filterAlertedFlights: boolean;
    onToggleFilterAlertedFlights: () => void;
}

const Header: FC<HeaderProps> = (props) => {
    const dashboardInfoProps = {
        dashboardName: props.dashboardName,
        dashboardLastUpdatedAt: props.dashboardLastUpdatedAt,
    };

    return (
        <header className="header" data-testid="header">
            <Link to="/dashboards" title="See all dashboards">
                <Logo />
            </Link>
            {props.dashboardId && <DashboardInfo {...dashboardInfoProps} />}
            <Navigation
                dashboardId={props.dashboardId}
                filterAlertedFlights={props.filterAlertedFlights}
                onToggleFilterAlertedFlights={props.onToggleFilterAlertedFlights}
            />
        </header>
    );
};

export default Header;
